module.exports = __webpack_public_path__ + "img/icon_add@3x.e56346bc.png";